import {FaStar, FaCaretRight, FaCaretDown, FaInfoCircle} from "react-icons/fa";
import ReactHtmlParser from "react-html-parser";
import React, {useEffect, useState, useMemo} from "react";
import styled from "styled-components";
import DiscoverAnnotationModal from "../../shared/Modal/DiscoverAnnotationModal";
import DiscoverService from "../../services/discoverService";
import _ from "lodash";
import pencilImg from "../../assets/image/pencil.png";
import notesImg from "../../assets/image/notes_small.png";
import { extractSeqIdNumber } from "../../helpers/utils";
import {withStyles} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";
import SeqIdAlignmentPopup from "./SeqIdAlignmentPopup";
import "./ResultTableRecDetails.css"

const Styles = styled.div`
  .pull-left {
    float: left !important;
  }
  .clearfix{*zoom:1;}.clearfix:before,.clearfix:after{display:table;content:"";line-height:0;}
  .clearfix() {
    &:before,
    &:after {
      content: " "; // 1
      display: table; // 2
    }
    &:after {
      clear: both;
    }
  }
  .gqcol {
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 8px;
    margin-left: 8px;
    min-height: 20px;
    min-width: 10px;
  }
  .gqcol-alignment {
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: visible;
    white-space: nowrap;
    margin-right: 8px;
    margin-left: 8px;
    min-height: 20px;
    min-width: 10px;
  }
  .gqcolhover {
    overflow: visible;
    white-space: normal;
  }

  .stars-div {
    letter-spacing: -2px;
    color: #D0D0D0;
    padding-top: 1px;
    padding-right: 3px;
    padding-left: 3px;
    cursor: pointer;
  }

  .text-nowrap {
    white-space: nowrap
  }

  .fa-star {
    display: inline-block;
    vertical-align: top;
  }
  
  .fa-caret {
    width: 10px;
  }

  .color-select {
    width: 30px;
    border: solid 1px #CCC;
    height: 16px;
    margin-top: 2px;
  }

  .fa-caret-down:before {
    content: "\f0d7";
  }

  ::-webkit-input-placeholder {
    font-style: italic;
    color: lightgrey;
  }

  :-moz-placeholder {
    font-style: italic;
    color: lightgrey;
  }

  ::-moz-placeholder {
    font-style: italic;
    color: lightgrey;
  }

  :-ms-input-placeholder {
    font-style: italic;
    color: lightgrey;
  }

  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
    top: -0.5em;
  }
  .color-box-container {
    background-color: #FFF;
    border: solid 1px #CCC;
    padding: 8px;
    width: 221px;
    vertical-align: top;
    position: absolute;
    margin-left: 30px;
    margin-top: -15px;
    /*z-index: 500;*/
  }
  .color-box {
    width: 25px;
    height: 25px;
    border: solid 1px #CCC;
    margin: 2px;
  }

  a {
    color: #337ab7 !important;
  }

  .color-select {
    width: 30px;
    border: solid 1px #CCC;
    height: 16px;
    margin-top: 2px;
  }
  .unsel-star {
    color: #DDD;
  }
  .sel-star {
    color: #999 !important;
  }
  .fa-caret-right:before {
    content: "\f0da";
  }
  table.classification tr td {
    padding-bottom: 4px;
    padding-right: 30px;
  }
  .detail-label-sub {
    width: 220px;
    padding-right: 10px;
    padding-left: 0px;
  }
  .side-label {
    width: 200px;
  }
  .selected-focus {
    background-color: #EAEAEA;
  }
  .selected-blur {
    background-color: #F4F4F4;
  }
  .selected-focus pre { /* For formatted alignments */
    background-color: #EAEAEA !important;
  }
  .selected-blur pre { /* For formatted alignments */
    background-color: #F4F4F4 !important;
  }
  .black-font {
    color: #555 !important;
    padding: 0px 3px 1px 3px;
    border: solid 1px #999;
    border-radius: 3px;
  }
  /* used to highlight the word SEQ ID NO in the claim text */
  .seq-id-no {
    text-decoration: underline;
    font-weight: bold;
  }
  .seq-id-no[data-seqid] {
    cursor: pointer;
  }
  .not-available {
    font-style: italic;
    color: #CCC;
  }
  /* colors for highlight of text */

  .highlight-FFEB3B {
    background-color: #FFEB3B;
    color: #000 !important;
  }

  .highlight-80CBC4 {
    background-color: #80CBC4;
    color: #000 !important;
  }

  .highlight-B39DDB {
    background-color: #B39DDB;
    color: #000 !important;
  }

  .highlight-EF9A9A {
    background-color: #EF9A9A;
    color: #000 !important;
  }

  .highlight-F48FB1 {
    background-color: #F48FB1;
    color: #000 !important;
  }

  .highlight-81D4FA {
    background-color: #81D4FA;
    color: #000 !important;
  }

  .highlight-A5D6A7 {
    background-color: #A5D6A7;
    color: #000 !important;
  }

  .highlight-E6EE9C {
    background-color: #E6EE9C;
    color: #000 !important;
  }

  .highlight-FFF59D {
    background-color: #FFF59D;
    color: #000 !important;
  }

  .highlight-FFE082 {
    background-color: #FFE082;
    color: #000 !important;
  }

  .highlight-FFCC80 {
    background-color: #FFCC80;
    color: #000 !important;
  }

  .highlight-FFAB91 {
    background-color: #FFAB91;
    color: #000 !important;
  }

  .highlight-FF7043 {
    background-color: #FF7043;
    color: #000 !important;
  }

  .highlight-FFA726 {
    background-color: #FFA726;
    color: #000 !important;
  }

  .highlight-BCAAA4 {
    background-color: #BCAAA4;
    color: #000 !important;
  }

  .highlight-B0BEC5 {
    background-color: #B0BEC5;
    color: #000 !important;
  }
  
  /* alignment mismatch and positive */
  .mismatch {
    background-color: yellow;
  }

  .match {
    background-color: orange;
  }

  .lva-not-exact-match {
    text-transform: lowercase;
  }

  .lva-marked {
    background-color: #337ab7;
    color: white;
  }

    .cm-mod-marker {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        width: 1ch;
        line-height: 1;
        height: auto;
        margin-top: 10px;
        overflow: visible;
        vertical-align: top;
        position: relative;
    }

    .cm-mod-marker.cm-mod-marker-flipped {
        flex-direction: column-reverse;
        margin-top: 0;
        margin-bottom: 10px;
    }

    .cm-mod-square {
        width: 6px;
        height: 6px;
        margin: 0 0 1px 0;
        display: block;
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-radius: 1px;
        box-sizing: border-box;
    }

    .cm-mod-arrow {
        font-size: 9px;
        line-height: 8px;
        color: #3a6fa9;
        margin-top: 0;
    }

    .cm-mod-bottom-bar {
        width: 100%;
        height: 3px;
        background-color: #3a6fa9;
        border-radius: 1px;
        margin-top: 0;
        display: block;
        position: static;
    }

    .cm-query-track {
        display: inline-block;
        position: relative;
        transform-origin: bottom center;
    }

  .lva-bar .tooltiptext {
    visibility: hidden;
    background-color: #777;
    color: #FFF;
    text-align: center;
    border-radius: 6px;
    padding: 6px 6px 6px 6px;
    box-shadow: 0px 1px 7px #888;

    font-size: 7pt;
    font-family: arial;

    /* Position the tooltip */
    position: absolute;
    bottom: 10%;
    left: 100%;
    margin-left: 10px;
    z-index: 9999;

    overflow: visible;
  }

  .lva-bar .tooltiptext:before {
    content: '';
    position: absolute;

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #777;
    left: -6px;
  }

  .lva-bar:hover .tooltiptext {
    visibility: visible;
  }

  .lva-bar .singletooltiptext {
    visibility: hidden;
    background-color: #777;
    color: #FFF;
    text-align: center;
    border-radius: 6px;
    padding: 6px 6px 6px 6px;
    box-shadow: 0px 1px 7px #888;

    font-size: 7pt;
    font-family: arial;

    /* Position the tooltip */
    position: absolute;
    bottom: 10%;
    margin-left: 2px;
    z-index: 10001;
  }

  .lva-bar .singletooltiptext:before {
    content: '';
    position: absolute;

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #777;
    left: -6px;
  }

  .lva-bar span:hover .singletooltiptext {
    visibility: visible;
  }

  .lva-bar span:hover ~ .tooltiptext {
    visibility: hidden;
  }
  .lvm-summary-header-row {
    width: 600px;
    text-align: center;
    margin-bottom: 10px;

    /*font-size: 9pt !important;*/
    font-weight: bold;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .lvm-summary-header-label {
    width: 400px;
  }

  .lvm-summary-sub-header {
    float: left;

    /*font-size: 9pt !important;*/
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .lvm-summary-gqcol {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 4px;
    margin-left: 4px;
    display: inline-block;
    float: left;
    width: 104px;

    /*font-size: 9pt !important;*/
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .lvm-summary-gqcol:hover {
    overflow: visible;
    white-space: normal;
  }

  .lvm-summary-row {
    white-space: nowrap;
  }

  .lvm-summary-link {
    position: relative;
    margin-right: 4px;
    margin-left: 4px;
    left: 450px;
  }

  .lvm-summary-link-label {
    float: left;
    vertical-align: middle;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
`
const toolTipStyles = {
    tooltip: {
        width: "auto",
        //height: "40px",
        fontSize: '12px',
        textAlign: 'justify',
        padding: "8px 14px 8px 14px",
        boxShadow: "0px 1px 7px #888",
        backgroundColor: '#777',
        color: '#FFF'
    }
};
const CustomTooltip = withStyles(toolTipStyles)(Tooltip);
const tooltipContent = "Annotate Records. Single click – single records, Double click – bulk records.";

function AlignmentHtmlWithTooltip({ html }) {
    const [tooltipTitle, setTooltipTitle] = useState('');
    const [tooltipAnchorEl, setTooltipAnchorEl] = useState(null);

    const handleMouseMove = (event) => {
        const square = event.target?.closest?.('.cm-mod-square[data-cm-tooltip]');
        const nextTitle = square?.getAttribute('data-cm-tooltip') || '';
        if (square !== tooltipAnchorEl) {
            setTooltipAnchorEl(square || null);
        }
        if (nextTitle !== tooltipTitle) {
            setTooltipTitle(nextTitle);
        }
    };

    return (
        <CustomTooltip
            arrow
            title={tooltipTitle}
            placement="top"
            open={Boolean(tooltipTitle) && Boolean(tooltipAnchorEl)}
            PopperProps={{ anchorEl: tooltipAnchorEl }}
            disableFocusListener
            disableHoverListener
            disableTouchListener
        >
            <span
                onMouseMove={handleMouseMove}
                onMouseLeave={() => {
                    setTooltipTitle('');
                    setTooltipAnchorEl(null);
                }}
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </CustomTooltip>
    );
}

/**
 * Build full subject sequence display with query alignment overlaid.
 * Replicates the Java buildFullQueryAlignment() from ExportServiceImpl.java
 */
export function buildFullSubjectAlignment(item, isCmNoSeq, cmTrackBuilder, lvaFlagMaps) {
    const fullSubjectSeq = item.RESULT_NFALI_FORMATTED;
    const normalAlignment = item.RESULT_FALI_FORMATTED;

    if (!fullSubjectSeq) return null;

    const CHUNK_SIZE = 60;
    const WINDOW = 120;
    const cleanSubject = fullSubjectSeq.replace(/\r?\n/g, '');
    const totalLen = cleanSubject.length;

    // CM no-seq mode: no real query sequence, just show subject-only chunks.
    // The subject CM track is added after each S: line to match colorAlignment's isCmNoSeq path.
    if (isCmNoSeq) {
        let result = '';
        const isCmNoSeqPrefixLen = 13; // 'S: ' (3) + padStart(9) + ' ' (1)

        // Build a map from absolute subject position → 1-based non-gap ordinal within the
        // aligned region (RESULT_FALI_FORMATTED). This enables alignment-relative CM patterns
        // ("first N", "last N", linked) to render correctly — buildSubjectCmChunkRanges reads
        // entry.sOrdinal for those patterns. Positions outside the aligned region are absent
        // from the map (null ordinal) so alignment-relative patterns never bleed into the flanks.
        // Gap chars ('-') advance neither the absolute position nor the ordinal.
        // Direction is derived from each S: line's start/stop labels, so reverse strands work.
        const subjectPosToOrdinal = new Map();
        if (normalAlignment) {
            const aliLines = normalAlignment.split(/\r?\n/);
            let ordinal = 0;
            for (const rawLine of aliLines) {
                const m = rawLine.match(/^(\s*S:\s*)(\d+)(\s+)(\S.*?)(\s+)(\d+)\s*$/);
                if (!m) continue;
                const startPos = parseInt(m[2], 10);
                const stopPos  = parseInt(m[6], 10);
                const seq = m[4];
                const forward = startPos <= stopPos;
                let absPos = startPos;
                for (let k = 0; k < seq.length; k++) {
                    if (seq[k] === '-') continue;
                    ordinal += 1;
                    subjectPosToOrdinal.set(absPos, ordinal);
                    absPos += forward ? 1 : -1;
                }
            }
        }

        for (let i = 0; i < totalLen; i += CHUNK_SIZE) {
            const chunkEnd = Math.min(i + CHUNK_SIZE, totalLen);
            const subjectChunk = cleanSubject.substring(i, chunkEnd);
            const chunkStartPos = i + 1;
            const chunkEndPos = chunkEnd;
            result += 'S: ' + String(chunkStartPos).padStart(9) + ' ' + subjectChunk + ' ' + chunkEndPos + '\n';
            if (cmTrackBuilder) {
                const entries = [];
                for (let k = 0; k < subjectChunk.length; k++) {
                    const sPos = chunkStartPos + k;
                    entries.push({
                        qChar: ' ', sChar: subjectChunk[k],
                        qPos: null, sPos,
                        qOrdinal: null,
                        sOrdinal: subjectPosToOrdinal.has(sPos) ? subjectPosToOrdinal.get(sPos) : null
                    });
                }
                const { subjectTrackLine } = cmTrackBuilder(item, entries, { queryPrefixLen: isCmNoSeqPrefixLen, subjectPrefixLen: isCmNoSeqPrefixLen });
                if (subjectTrackLine) result += subjectTrackLine + '\n';
            }
            result += '\n';
        }
        return result.trimEnd();
    }

    if (!normalAlignment) return null;

    // Parse positions + line format (position width, post-position gap, pre-endpos gap)
    // so emitted chunks visually align with the original alignment's Q:/S: lines.
    let queryStartPos = 1;
    let queryEndPos = -1;
    let subjectStartFromAli = -1;
    let subjectStopFromAli = -1;
    let queryStartSeen = false;
    const detectFormat = (raw, prefix) => {
        const m = raw.match(new RegExp('^(\\s*' + prefix + ':\\s*)(\\d+)(\\s+)(\\S.*?)(\\s+)(\\d+)\\s*$'));
        if (!m) return null;
        return { posWidth: (m[1].length - 2) + m[2].length, seqGap: m[3], endGap: m[5] };
    };
    let sFormat = null;
    let qFormat = null;

    const lines = normalAlignment.split(/\r?\n/);
    for (const rawLine of lines) {
        const line = rawLine.trim();
        if (line.startsWith('Q:')) {
            const parts = line.split(/\s+/);
            if (parts.length >= 4) {
                if (!queryStartSeen) {
                    queryStartPos = parseInt(parts[1]) || 1;
                    queryStartSeen = true;
                }
                const qEnd = parseInt(parts[parts.length - 1]);
                if (!isNaN(qEnd)) queryEndPos = qEnd;
            }
            if (!qFormat) qFormat = detectFormat(rawLine, 'Q');
        } else if (line.startsWith('S:')) {
            const parts = line.split(/\s+/);
            if (parts.length >= 4) {
                if (subjectStartFromAli === -1) {
                    subjectStartFromAli = parseInt(parts[1]) || -1;
                }
                subjectStopFromAli = parseInt(parts[parts.length - 1]) || -1;
            }
            if (!sFormat) sFormat = detectFormat(rawLine, 'S');
        }
    }
    if (!sFormat) sFormat = { posWidth: 5, seqGap: '  ', endGap: '  ' };
    if (!qFormat) qFormat = { posWidth: 5, seqGap: '  ', endGap: '  ' };

    let isReverseStrand = false;
    const nfq = parseInt(item.RESULT_NFQ) || 0;
    if (nfq >= 3 && nfq <= 6) isReverseStrand = true;
    if (!isReverseStrand && subjectStartFromAli !== -1 && subjectStopFromAli !== -1 && subjectStartFromAli > subjectStopFromAli) {
        isReverseStrand = true;
    }

    const reverseComplement = (seq) => {
        const comp = { A: 'T', T: 'A', G: 'C', C: 'G', U: 'A', a: 't', t: 'a', g: 'c', c: 'g', u: 'a' };
        return seq.split('').reverse().map(c => comp[c] || c).join('');
    };
    const displaySeq = isReverseStrand ? reverseComplement(cleanSubject) : cleanSubject;

    let matchStartIdx, matchEndIdx;
    if (subjectStartFromAli === -1) {
        matchStartIdx = 0;
        matchEndIdx = totalLen - 1;
    } else if (isReverseStrand) {
        const highPos = Math.max(subjectStartFromAli, subjectStopFromAli);
        const lowPos = Math.min(subjectStartFromAli, subjectStopFromAli);
        matchStartIdx = totalLen - highPos;
        matchEndIdx = totalLen - lowPos;
    } else {
        matchStartIdx = Math.min(subjectStartFromAli, subjectStopFromAli) - 1;
        matchEndIdx = Math.max(subjectStartFromAli, subjectStopFromAli) - 1;
    }

    // --- Continuous alignment: merge 5' flank + aligned region + 3' flank into one
    // positionally-aligned column space, then wrap at CHUNK_SIZE and emit labeled
    // Q:/match/S: triplets with no blank-line gaps between the aligned region and its flanks.

    // 1. Parse the aligned region (RESULT_FALI_FORMATTED) into three concatenated plain
    // strings: alignedQuery, alignedMatch, alignedSubject. Gap chars ('-') are kept as
    // real columns (they occupy space but do not advance sequence coordinates).
    const parseAlignedRegion = (alignText) => {
        const aLines = alignText.split(/\r?\n/);
        let alignedQuery = '', alignedMatch = '', alignedSubject = '';
        let i = 0;
        while (i < aLines.length) {
            const rawLine = aLines[i];
            if (rawLine.trim().startsWith('Q:')) {
                const qm = rawLine.match(/^(\s*Q:\s*\d+\s+)(\S.*?)(\s+\d+\s*)$/);
                const qSeq = qm ? qm[2] : '';
                const qPrefixLen = qm ? qm[1].length : 0;
                // Advance past optional blank lines to the match line
                let j = i + 1;
                while (j < aLines.length && aLines[j].trim() === '') j++;
                let matchRaw = '';
                if (j < aLines.length && !aLines[j].trim().startsWith('Q:') && !aLines[j].trim().startsWith('S:')) {
                    matchRaw = aLines[j];
                    j++;
                }
                while (j < aLines.length && aLines[j].trim() === '') j++;
                let sSeq = '';
                if (j < aLines.length && aLines[j].trim().startsWith('S:')) {
                    const sm = aLines[j].match(/^(\s*S:\s*\d+\s+)(\S.*?)(\s+\d+\s*)$/);
                    sSeq = sm ? sm[2] : '';
                    j++;
                }
                const blockWidth = Math.max(qSeq.length, sSeq.length);
                alignedQuery   += qSeq.padEnd(blockWidth);
                alignedSubject += sSeq.padEnd(blockWidth);
                // Extract the match symbols that sit under the sequence columns of the Q: line
                alignedMatch   += matchRaw.substring(qPrefixLen, qPrefixLen + blockWidth).padEnd(blockWidth);
                i = j;
            } else {
                i++;
            }
        }
        return { alignedQuery, alignedMatch, alignedSubject, alignedWidth: alignedQuery.length };
    };
    const { alignedQuery, alignedMatch, alignedSubject, alignedWidth } = parseAlignedRegion(normalAlignment);

    // 2. Capture flank/overhang strings (ungapped) and the displaySeq/query index of each
    // region's first character, for use when building coordinate arrays.
    const fullQuery = (item.QUERY_O || '').replace(/\r?\n/g, '');

    const flankStart5 = matchStartIdx > 0 ? Math.max(0, matchStartIdx - WINDOW) : matchStartIdx;
    const subj5 = matchStartIdx > 0 ? displaySeq.substring(flankStart5, matchStartIdx) : '';

    const flankEnd3 = matchEndIdx < totalLen - 1 ? Math.min(totalLen - 1, matchEndIdx + WINDOW) : matchEndIdx;
    const subj3 = matchEndIdx < totalLen - 1 ? displaySeq.substring(matchEndIdx + 1, flankEnd3 + 1) : '';

    let q5 = '', q5Start = 1;
    if (queryStartPos > 1 && fullQuery) {
        const overhangStart = Math.max(1, queryStartPos - WINDOW);
        const overhangEnd = Math.min(queryStartPos - 1, fullQuery.length);
        if (overhangEnd >= overhangStart) {
            q5 = fullQuery.substring(overhangStart - 1, overhangEnd);
            q5Start = overhangStart;
        }
    }

    let q3 = '', q3Start = queryEndPos + 1;
    if (queryEndPos > 0 && fullQuery && queryEndPos < fullQuery.length) {
        q3 = fullQuery.substring(queryEndPos, Math.min(queryEndPos + WINDOW, fullQuery.length));
        q3Start = queryEndPos + 1;
    }

    // 3. Build three full-width column strings.
    // 5' contexts are right-aligned (they butt up against the alignment start).
    // 3' contexts are left-aligned (they begin immediately after the alignment end).
    const leftWidth  = Math.max(subj5.length, q5.length);
    const rightWidth = Math.max(subj3.length, q3.length);
    const totalCols  = leftWidth + alignedWidth + rightWidth;

    const subjectRow = subj5.padStart(leftWidth) + alignedSubject + subj3.padEnd(rightWidth);
    const queryRow   = q5.padStart(leftWidth)    + alignedQuery   + q3.padEnd(rightWidth);

    // 4. Gap-aware, reverse-aware coordinate arrays.
    // qCoord[col] and sCoord[col] hold the 1-based position label for that column,
    // or null for padding spaces / gap characters.
    const qCoord = new Array(totalCols).fill(null);
    const sCoord = new Array(totalCols).fill(null);
    const subjLabel = (dispIdx) => isReverseStrand ? totalLen - dispIdx : dispIdx + 1;

    // Query: 5' overhang (right-aligned into the left block)
    let qPos = q5Start;
    const q5ColOffset = leftWidth - q5.length;
    for (let k = 0; k < q5.length; k++) {
        if (q5[k] !== ' ') qCoord[q5ColOffset + k] = qPos++;
    }
    // Query: aligned region (gap chars '-' do not advance the coordinate)
    qPos = queryStartPos;
    for (let k = 0; k < alignedWidth; k++) {
        const ch = alignedQuery[k];
        if (ch && ch !== ' ' && ch !== '-') qCoord[leftWidth + k] = qPos++;
    }
    // Query: 3' continuation (left-aligned into the right block)
    qPos = q3Start;
    for (let k = 0; k < q3.length; k++) {
        if (q3[k] !== ' ') qCoord[leftWidth + alignedWidth + k] = qPos++;
    }

    // Subject: 5' flank (right-aligned into the left block)
    const s5ColOffset = leftWidth - subj5.length;
    for (let k = 0; k < subj5.length; k++) {
        if (subj5[k] !== ' ') sCoord[s5ColOffset + k] = subjLabel(flankStart5 + k);
    }
    // Subject: aligned region (gap chars do not advance the displaySeq index)
    let sDispIdx = matchStartIdx;
    for (let k = 0; k < alignedWidth; k++) {
        const ch = alignedSubject[k];
        if (ch && ch !== ' ' && ch !== '-') {
            sCoord[leftWidth + k] = subjLabel(sDispIdx);
            sDispIdx++;
        }
    }
    // Subject: 3' flank (left-aligned into the right block)
    for (let k = 0; k < subj3.length; k++) {
        sCoord[leftWidth + alignedWidth + k] = subjLabel(matchEndIdx + 1 + k);
    }

    // Ordinal arrays for CM alignment-relative patterns.
    // buildSubjectCmChunkRanges / buildDirectQueryCmChunkRanges use entry.sOrdinal / entry.qOrdinal
    // for patterns with alignmentRelative:true (e.g. "first N positions").
    // Ordinals count non-gap characters within the aligned region, starting at 1.
    // Flank/overhang/continuation columns have null ordinals (outside the alignment).
    const qOrdinalArr = new Array(totalCols).fill(null);
    const sOrdinalArr = new Array(totalCols).fill(null);
    let qOrd = 0, sOrd = 0;
    for (let k = 0; k < alignedWidth; k++) {
        if (alignedQuery[k] && alignedQuery[k] !== ' ' && alignedQuery[k] !== '-') {
            qOrdinalArr[leftWidth + k] = ++qOrd;
        }
        if (alignedSubject[k] && alignedSubject[k] !== ' ' && alignedSubject[k] !== '-') {
            sOrdinalArr[leftWidth + k] = ++sOrd;
        }
    }

    // 5 & 6. Wrap at CHUNK_SIZE and emit labeled Q:/match/S: triplets.
    // All column math is done on plain text; coloring spans are inserted last so they
    // never break the fixed-width column arithmetic.
    // Windows with no query characters (subject-only flank regions) emit only the S: line.
    const colorizeMatch = (m) =>
        m
            .replace(/ +/g, hit => '<span class="mismatch">' + hit + '</span>')
            .replace(/\++/g, hit => '<span class="match">' + hit + '</span>');

    // Column offset in each rendered line where the sequence chars begin,
    // used to indent the match-symbol line so symbols sit directly below the sequence.
    const matchIndent      = 2 + qFormat.posWidth + qFormat.seqGap.length;
    const subjectPrefixLen = 2 + sFormat.posWidth + sFormat.seqGap.length;

    // Wrap sequence characters with LVA highlight spans where flagged.
    // flag 1 → lva-marked (blue); flag > 1 → lva-marked lva-not-exact-match (blue + lowercase).
    // Called after all column math so spans never disturb coordinate arithmetic.
    const wrapLva = (row, coordArr, flagMap, startCol, endCol) => {
        if (!flagMap || flagMap.size === 0) return row.slice(startCol, endCol);
        let out = '';
        for (let c = startCol; c < endCol; c++) {
            const ch   = row[c] ?? ' ';
            const pos  = coordArr[c];
            const flag = pos !== null ? (flagMap.get(pos) ?? 0) : 0;
            if (flag === 1)     out += "<span class='lva-marked'>" + ch + "</span>";
            else if (flag > 1)  out += "<span class='lva-marked lva-not-exact-match'>" + ch + "</span>";
            else                out += ch;
        }
        return out;
    };

    let result = '';
    for (let startCol = 0; startCol < totalCols; startCol += CHUNK_SIZE) {
        const endCol = Math.min(startCol + CHUNK_SIZE, totalCols);

        // Gather coordinate labels for this window
        let qStart = null, qEnd = null, sStart = null, sEnd = null;
        for (let c = startCol; c < endCol; c++) {
            if (qCoord[c] !== null) { if (qStart === null) qStart = qCoord[c]; qEnd = qCoord[c]; }
            if (sCoord[c] !== null) { if (sStart === null) sStart = sCoord[c]; sEnd = sCoord[c]; }
        }

        // Build per-column entries for the CM track builder (plain text, no LVA spans).
        // qPos/sPos are null for padding/gap columns; buildCmTrackLine skips those via Number.isFinite.
        // qOrdinal/sOrdinal are the sequential non-gap counts within the aligned region, required
        // by buildSubjectCmChunkRanges / buildDirectQueryCmChunkRanges for alignmentRelative patterns.
        const entries = [];
        for (let c = startCol; c < endCol; c++) {
            entries.push({
                qChar: queryRow[c] || ' ', sChar: subjectRow[c] || ' ',
                qPos: qCoord[c], sPos: sCoord[c],
                qOrdinal: qOrdinalArr[c], sOrdinal: sOrdinalArr[c]
            });
        }

        // CM marker tracks (null when isCmWorkflow is false or no markers in this window)
        const { queryTrackLine = null, subjectTrackLine = null } = cmTrackBuilder
            ? cmTrackBuilder(item, entries, { queryPrefixLen: matchIndent, subjectPrefixLen })
            : {};

        // LVA-wrapped sequence slices (identity if no flag maps)
        const qSliceWrapped = wrapLva(queryRow,   qCoord, lvaFlagMaps?.qFlags, startCol, endCol);
        const sSliceWrapped = wrapLva(subjectRow,  sCoord, lvaFlagMaps?.sFlags, startCol, endCol);

        const hasQuery      = qStart !== null;
        const overlapsAlign = startCol < leftWidth + alignedWidth && endCol > leftWidth;

        // Query CM track — above the Q: line (mirrors colorAlignment line 4576-4578)
        if (hasQuery && queryTrackLine) {
            result += queryTrackLine + '\n';
        }

        // Q: line — omit for subject-only flank windows (no query chars in this window)
        if (hasQuery) {
            result += `Q:${String(qStart).padStart(qFormat.posWidth)}${qFormat.seqGap}${qSliceWrapped}${qFormat.endGap}${qEnd}\n`;
        }

        // Match line — only when Q: is emitted and this window overlaps the aligned region.
        // Colorize only the actual match symbols (not flank-side spaces) so the mismatch
        // span does not accidentally highlight structural padding.
        if (hasQuery && overlapsAlign) {
            const symStart     = Math.max(startCol, leftWidth);
            const symEnd       = Math.min(endCol, leftWidth + alignedWidth);
            const prefixSpaces = symStart - startCol;
            const matchSymbols = alignedMatch.slice(symStart - leftWidth, symEnd - leftWidth);
            result += ' '.repeat(matchIndent + prefixSpaces) + colorizeMatch(matchSymbols) + '\n';
        }

        // S: line — always emitted; the subject runs as one continuous sequence.
        if (sStart !== null) {
            result += `S:${String(sStart).padStart(sFormat.posWidth)}${sFormat.seqGap}${sSliceWrapped}${sFormat.endGap}${sEnd}\n`;
        }

        // Subject CM track — below the S: line (mirrors colorAlignment lines 4688-4690)
        if (sStart !== null && subjectTrackLine) {
            result += subjectTrackLine + '\n';
        }

        result += '\n';
    }

    return result.trimEnd();
}

// True for either alignment column id — both map to a single swappable slot
const isAlignmentSlot = (c) => c === 'RESULT_FALI_FORMATTED' || c === 'RESULT_EXTENDED_ALI';

export default function ResultTableRecord({ data, item, idx, fieldConfig, filter, annotState,
                                              highlight, toggleFullRecordExpand, columns,refreshAnnotState,
                                              fromItemsPage, groupValue1, groupValue2, saveAnnotation, parentAnnotState,
                                              resizeColCallback, setFtWindowsToOpen, selectedRowKey, rowUniqueKey, showFullSubject, flankWidth, onToggleFullSubject, isCmNoSeq,
                                              buildExtendedCmTracks, getExtendedLvaFlagMaps }) {
    const[tableState, setTableState] = useState(annotState);
    // Compute LVA flag maps once per item — position-keyed flags for extended alignment highlighting
    const lvaFlagMaps = useMemo(() => getExtendedLvaFlagMaps?.(item), [item, getExtendedLvaFlagMaps]);
    const[key, setKey] = useState('');
    const[type, setType] = useState('');
    const[value, setValue] = useState(0);
    const[showAnnotationModal,setShowAnnotationModal] = useState(false);
    const[showColor,setShowColor] = useState(false);
    let singleClickTimer = null;
    const[showTooltip,setShowTooltip] = useState(tooltipContent);

    const [dragging, setDragging] = useState(()=>false);
    const [colConfig, setColConfig] = useState(_.cloneDeep(fieldConfig.fieldConfig));
    const [lastPos, setLastPos] = useState(0);
    const toggle = useSelector(state => state.setToggle.toggle);

    const[annotGroup, setAnnotGroup] = useState('');
    const[annotGroupDisplay, setAnnotGroupDisplay] = useState('');
    const[annotSubjectId, setAnnotSubjectId] = useState('');
    const[annotSubjectPn, setAnnotSubjectPn] = useState('');

    useEffect( async() => {
        setTableState({...annotState});
    },[annotState]);

    // Add effect to sync stars and colors from annotState
    useEffect(() => {
        if (item.dbkey && annotState) {
            const needsUpdate = 
                tableState.stars[item.dbkey] !== annotState.stars[item.dbkey] ||
                tableState.colors[item.dbkey] !== annotState.colors[item.dbkey];
            
            if (needsUpdate) {
                setTableState({...annotState});
            }
        }
    }, [annotState.stars?.[item.dbkey], annotState.colors?.[item.dbkey]]);

    // Listen for messages from the popup window in openDetailsinNewPage, to update annotations and sync state across windows
   useEffect(() => {
    const handleMessage = (event) => {
        if (event.origin !== window.location.origin) return;

        if (event.data.type === 'ANNOTATION_UPDATE') {
            setTableState(prev => {
                const next = { ...prev };

                if (event.data.annotType === 'star') {
                    next.stars[event.data.key] = event.data.value;
                } else if (event.data.annotType === 'color') {
                    next.colors[event.data.key] = event.data.value;
                } else if (event.data.annotType === 'notes') {
                    next.notes[event.data.key] = event.data.value;
                }

                return next;
            });
        }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
}, []);


    const callBack = (type, choice, annotated, key, value, annotState,
        filter, fieldConfig, fromItemsPage, groupValue1, groupValue2) => {
        saveAnnotation(type, choice, annotated, key, value, annotState,
            filter, fieldConfig, fromItemsPage, groupValue1, groupValue2, parentAnnotState);
        closeModal();
    }

    const closeModal = () => {
        setShowAnnotationModal(false);
    }

    const toggleCheckbox = (e, key, fieldConfig, item) => {
        if (singleClickTimer !== null) {
            clearTimeout(singleClickTimer);
            singleClickTimer = null;
            handleDoubleClick(key, 'checkbox', annotState.checkboxes[key] ? 1 : 0, fieldConfig, item);
        } else {
            singleClickTimer = setTimeout(() => {
                annotState.checkboxes[key] = !annotState.checkboxes[key];
                if (fromItemsPage) {
                    parentAnnotState.checkboxes[key] = annotState.checkboxes[key];
                }
                setTableState({...annotState});
                saveSingleAnnotation('checkbox', key, annotState.checkboxes[key]);
                clearTimeout(singleClickTimer);
                singleClickTimer = null;
            },  300);
        }
    }

    const handleDoubleClick = (key, type, value, fieldConfig, item) => {
        setKey(key);
        setType(type);
        setValue(value);
        calAnnotGroup(fieldConfig, item);
        setShowAnnotationModal(true);
    }

    const toggleStars = (e, key, nbStars, fieldConfig, item) => {
        if (singleClickTimer !== null) {
            clearTimeout(singleClickTimer);
            singleClickTimer = null;
            handleDoubleClick(key, 'star', annotState.stars[key] ? annotState.stars[key] : 0, fieldConfig, item);
        } else {
            singleClickTimer = setTimeout(() => {
                annotState.stars[key] = (annotState.stars[key] === nbStars) ? 0 : nbStars;
                if (fromItemsPage) {
                    parentAnnotState.stars[key] = annotState.stars[key];
                }
                setTableState({...annotState});
                saveSingleAnnotation('star', key, annotState.stars[key]);
                if (typeof refreshAnnotState === 'function') {
                    refreshAnnotState({...annotState});
                }
                clearTimeout(singleClickTimer);
                singleClickTimer = null;
            },  300);
        }
    }

    const calAnnotGroup = (fieldConfig, item) => {
        setAnnotSubjectId(item["SUBJECT_ID"] || '');
        setAnnotSubjectPn(item["SUBJECT_PN"] || '');
        if (!groupValue1) {
            let groupVal = "";
            let groupName = "";
            // Allow batch update annotations for normal groups except CAS/HSP groups
            switch (fieldConfig.tableDisplayMode) {
                case 'family':
                    groupVal = item["SUBJECT_PB"];
                    groupName = "Patent Family";
                    break;
                case 'document':
                    groupVal = item["SUBJECT_PN"];
                    groupName = "Patent Number";
                    break;
                case 'ufs':
                    groupVal = item["SUBJECT_PJ"];
                    groupName = "Unique Family Sequence";
                    break;
                /*case 'cas':
                    groupVal = item["SUBJECT_RG"];
                    groupName = "CAS Registry Number";
                    break;*/
                case 'ssv':
                    groupVal = item["SUBJECT_ID"];
                    groupName = "Subject Sequence";
                    break;
                case 'qs':
                    groupVal = item["QUERY_ID"];
                    groupName = "Query Sequence";
                    break;
                default:
                    break;
            }
            setAnnotGroup(groupVal);
            setAnnotGroupDisplay(groupName);
        }
    }

    const showColorBox = (e, key) => {
        if (singleClickTimer !== null) {
            clearTimeout(singleClickTimer);
            singleClickTimer = null;
            handleDoubleClick(key, 'color', annotState.colors[key] ? annotState.colors[key] : 0, fieldConfig, item);
        } else {
            singleClickTimer = setTimeout(() => {
                //if (!tableState.showColorBoxes) {
                   // tableState.showColorBoxes = {};
                //}
                setShowTooltip('');
                setShowColor(true);
                setTableState({...tableState});
                clearTimeout(singleClickTimer);
                singleClickTimer = null;
            },  300);
        }
    }

    const hideColorBox = (key) => {
        setShowColor(false);
        setShowTooltip(tooltipContent);
        //setTableState({...tableState});
    }

    const selectColor = (key, value, fieldConfig, item) => {
        setShowColor(false);
        setShowTooltip('');
        annotState.colors[key] = value;
        tableState.colors[key] = value;
        if (fromItemsPage) {
            parentAnnotState.colors[key] = annotState.colors[key];
        }
        setTableState({...tableState});
        saveSingleAnnotation('color', key, value);
        if (typeof refreshAnnotState === 'function') {
            refreshAnnotState({...annotState});
        }
    }

    const saveSingleAnnotation = (annotType, key, val) => {
        let call = window.$javaCall;
        let selectedIds = [];
        selectedIds.push(tableState.dbkeys[key]);
        call.data['selectedIds'] = selectedIds;
        call.data['allPages'] = false;
        let intVal = 0;
        if (typeof val === "boolean") {
            intVal = val ? 1: 0;
        } else {
            intVal = val;
        }
        call.data['value'] = intVal;
        call.data['annotType'] = annotType;
        DiscoverService.saveAnnotation(call.data, call.data.gqApiKey);
    }
    const onMouseOver = (event, id, col) =>{
      let element = document.getElementById(id);
      element.style.whiteSpace = 'pre-wrap'; // wrap attribute is not working in FF
    }
    const onMouseOut = (event, id, col)=>{
      let element = document.getElementById(id);
      element.style.whiteSpace = 'nowrap';
    }

    const onMouseMove = (event, id, col) => {
        let element = document.getElementById(id);
        let inDragTarget = (event.clientX >= (element.getClientRects()[0].right - 20));
        element.style.cursor = inDragTarget ? 'ew-resize' : 'default';
        element.style.borderRight = inDragTarget ? 'solid 3px #888' : 'none';
        //console.log("onMouseMove.");
    }

    const onMouseDown = (event, id, col) => {
        let element = document.getElementById(id);
        let inDragTarget = (event.clientX >= (element.getClientRects()[0].right - 20));
        if (inDragTarget && !dragging) {
            setDragging(true);
            //setLastPos(event.clientX);
            const firstPos = event.pageX;

            // this is what gets executed while the column size is being dragged
            const draggingNow = function (ev) {
                // Base the drag on the RENDERED width: while flanking shows an ephemeral fitted
                // width, start from flankWidth (not the persisted colwidth) so the column doesn't
                // jump on grab. Falls through to colwidth for every normal column.
                let oldWidth = (isAlignmentSlot(col) && showFullSubject && flankWidth != null) ? flankWidth : parseInt(fieldConfig.fieldConfig[col].colwidth);
                if (oldWidth < 0 || oldWidth > 1000) {
                    oldWidth = 130;
                }
                //console.log("draggingNow: " + (element.getClientRects()[0].right - 20) + ", now:" + ev.target.getBoundingClientRect().right);
                let newWidth = ev.pageX - firstPos + oldWidth;
                if (newWidth !== undefined && newWidth >= 30 && newWidth < 1000) {
                    //setLastPos(ev.clientX);
                    element.style.width = newWidth + 'px';
                    //console.log("newWidth: " + newWidth);
                }
            };

            // this is what gets executed when mouse cursor goes back up after dragging
            const stopDragging = function (ev) {
                // Base the drag on the RENDERED width: while flanking shows an ephemeral fitted
                // width, start from flankWidth (not the persisted colwidth) so the column doesn't
                // jump on grab. Falls through to colwidth for every normal column.
                let oldWidth = (isAlignmentSlot(col) && showFullSubject && flankWidth != null) ? flankWidth : parseInt(fieldConfig.fieldConfig[col].colwidth);
                if (isNaN(oldWidth) || oldWidth < 0 || oldWidth > 1000) {
                    oldWidth = 130;
                }
                // Clamp the final width into the valid range and ALWAYS commit it (plus a
                // parent re-render via resizeColCallback), so an out-of-bounds drag can no
                // longer leave this cell imperatively stuck while the header/other rows stay.
                let width = ev.pageX - firstPos + oldWidth;
                width = Math.max(30, Math.min(width, 999));
                fieldConfig.fieldConfig[col].colwidth = width;
                // Normalize the imperatively-mutated inline width back to the committed
                // colwidth so this cell matches the width the re-render gives every row.
                element.style.width = width + 'px';
                resizeColCallback(col, width, width - oldWidth);
                setDragging(false);
                document.body.removeEventListener("mousemove", draggingNow);
                document.body.removeEventListener("mouseup", stopDragging);
            };

            // dragging has started, attach events while dragging, and when dragging stops to body
            document.body.addEventListener("mousemove", draggingNow);
            document.body.addEventListener("mouseup", stopDragging);
        }
    }

    const onMouseLeave = (id, col, fieldConfig, filter) => {
        let element = document.getElementById(id);
        element.style.borderRight = 'none';
        element.style.cursor = 'default';
        if (dragging && colConfig[col].colwidth !== fieldConfig.fieldConfig[col].colwidth) {
            // When the col width is changed, saves it
            //fieldConfig.saveConfig(fieldConfig, 'default', filter);
            setDragging(false);
            //console.log("onMouseLeave");
        }
    }

    const showUpdateNotes = (e, key, fieldConfig, item) => {
        // Set parameters and open the popup dialog
        setType('notes');
        setValue(annotState.notes[key]);
        setKey(key);
        calAnnotGroup(fieldConfig, item);
        setShowAnnotationModal(true);
    }

    const openFtWindow = (thing)=>{

      let data ={
          pn: getWordAfterFulldocview(thing.VT_FT),
          seqIds: extractSeqIdNumber(thing),
          kws: ""
      }
      setFtWindowsToOpen(data)
    }

    function getWordAfterFulldocview(inputString) {
      const regex = /fulldocview\/(\w+)/;
      const match = inputString.match(regex);
      return match ? match[1] : null;
    }

    const handleRecordClick = () => {
        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
    };
    
    // Ref for the row div
    const rowRef = React.useRef(null);

    // Scroll into view if selected
    React.useEffect(() => {
        if (selectedRowKey === (rowUniqueKey || item.dbkey) && rowRef.current) {
            
            const rowRect = rowRef.current.getBoundingClientRect();
            const table = document.getElementById('result-container');
            
            if (table) {
                const tableRect = table.getBoundingClientRect();
                if (rowRect.top < tableRect.top || rowRect.bottom > tableRect.bottom) {
                    rowRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } else {
                // fallback: scroll in viewport
                rowRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [selectedRowKey, rowUniqueKey, item.dbkey]);

    return (
        <Styles>
            <div
                ref={rowRef}
                key={'row' + item.dbkey}
                className={`clearfix row-padding ${selectedRowKey === (rowUniqueKey || item.dbkey) ? 'selected-focus' : ''}`}
                style={{
                    backgroundColor: selectedRowKey === (rowUniqueKey || item.dbkey) ? '#bcdcefff' : 'transparent',
                    borderLeft: selectedRowKey === (rowUniqueKey || item.dbkey) ? '4px solid #4581e1ff' : 'none',
                    cursor: 'pointer',
                    color: selectedRowKey === (rowUniqueKey || item.dbkey) ? '#292929' : ''
                }}
            >
                <span id="RESULT_ID_{{item['RESULT_ID']}}" style={{display: 'none'}}>{item['RESULT_ID']}</span>
                {(item['type'] === 'sin' || item['type'] === 'flat') &&
                    <CustomTooltip arrow title={"Annotate Records. Single click – single record, Double click – bulk records."} placement="top" enterDelay={400} leaveDelay={10}>
                    <div className="pull-left">
                        <div className="checkbox-div pull-left">
                                <input id={'cb_'+item.dbkey} type="checkbox" onClick={(e) => {
                                    e.stopPropagation();
                                    toggleCheckbox(e, item.dbkey, fieldConfig, item);
                                }}
                                   onChange={(e) => e.preventDefault()}
                                   checked={annotState.checkboxes[item.dbkey] || false}/>
                            
                        </div>
                        
                            
                            <div className="stars-div text-nowrap pull-left">
                                <FaStar className="fa fa-star" color={(annotState.stars[item.dbkey] && annotState.stars[item.dbkey]>0) ? '#999' : '#DDD'} onClick={(e) => {
                                    e.stopPropagation();
                                    toggleStars(e, item.dbkey, 1, fieldConfig, item);
                                }}></FaStar>
                                <FaStar className="fa fa-star" color={(annotState.stars[item.dbkey] && annotState.stars[item.dbkey]>1) ? '#999' : '#DDD'} onClick={(e) => {
                                    e.stopPropagation();
                                    toggleStars(e, item.dbkey, 2, fieldConfig, item);
                                }}></FaStar>
                                <FaStar className="fa fa-star" color={(annotState.stars[item.dbkey] && annotState.stars[item.dbkey]>2) ? '#999' : '#DDD'} onClick={(e) => {
                                    e.stopPropagation();
                                    toggleStars(e, item.dbkey, 3, fieldConfig, item);
                                }}></FaStar>&nbsp;
                            </div>
                        
                        <div className="color-select-div pull-left" onMouseLeave={() => hideColorBox(item.dbkey)}>
                            
                                <div id={'col_'+item.dbkey} className={'pull-right color-select color-' + ((annotState.colors[item.dbkey] && annotState.colors[item.dbkey] > 0) ? annotState.colors[item.dbkey] : 0)} onClick={(e) => {
                                    e.stopPropagation();
                                    showColorBox(e, item.dbkey);
                                }}>
                                {showColor &&
                                    <div tabIndex="0" id={'cob_'+item.dbkey} className="clearfix color-box-container" onBlur={() => hideColorBox(item.dbkey)}
                                        onMouseLeave={() => hideColorBox(item.dbkey)} >
                                        <div onClick={(e)=>{selectColor(item.dbkey, 0, fieldConfig, item);e.stopPropagation();}} className="color-0 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 1, fieldConfig, item);e.stopPropagation();}} className="color-1 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 2, fieldConfig, item);e.stopPropagation();}} className="color-2 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 3, fieldConfig, item);e.stopPropagation();}} className="color-3 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 4, fieldConfig, item);e.stopPropagation();}} className="color-4 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 5, fieldConfig, item);e.stopPropagation();}} className="color-5 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 6, fieldConfig, item);e.stopPropagation();}} className="color-6 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 7, fieldConfig, item);e.stopPropagation();}} className="color-7 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 8, fieldConfig, item);e.stopPropagation();}} className="color-8 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 9, fieldConfig, item);e.stopPropagation();}} className="color-9 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 10, fieldConfig, item);e.stopPropagation();}} className="color-10 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 11, fieldConfig, item);e.stopPropagation();}} className="color-11 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 12, fieldConfig, item);e.stopPropagation();}} className="color-12 color-box pull-left"></div>
                                        <div onClick={(e)=>{selectColor(item.dbkey, 13, fieldConfig, item);e.stopPropagation();}} className="color-13 color-box pull-left"></div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="pull-left">
                            <div className={"appTextColor loginTitle"}>
                                <img onClick={e => {
                                    e.stopPropagation();
                                    showUpdateNotes(e, item.dbkey, fieldConfig, item);
                                }} src={(annotState.notes[item.dbkey] && annotState.notes[item.dbkey] !== '') ? notesImg : pencilImg}/>&nbsp;
                            </div>
                        </div>
                    </div>
                    </CustomTooltip>
                }

                <div className="pull-left fa-caret">
                    <a href="#" onClick={(e) => {
                        e.stopPropagation(); 
                        e.preventDefault();
                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                    }}>
                        {tableState.fullRecordExpand[item.dbkey] &&
                            <FaCaretDown/>
                        }
                        {!tableState.fullRecordExpand[item.dbkey] &&
                            <FaCaretRight/>
                        }
                    </a>
                </div>

                {columns?.map(
                        (col, colIdx) => 
                        (
                            <React.Fragment key={col + colIdx}>
                            <div className={'pull-left ' + (isAlignmentSlot(col) ? 'gqcol-alignment' : 'gqcol')}
                                 id={col + item.dbkey}
                                 onMouseMove={(e) => onMouseMove(e, col + item.dbkey, col)}
                                 onMouseOver={(e) => onMouseOver(e, col + item.dbkey, col)}
                                 onMouseOut={(e) => onMouseOut(e, col + item.dbkey, col)}
                                 onMouseDown={(e) => onMouseDown(e, col + item.dbkey, col)}
                                 onMouseLeave={() => onMouseLeave(col + item.dbkey, col, fieldConfig, filter)}
                                 style={{ width: (isAlignmentSlot(col) && showFullSubject && flankWidth != null ? flankWidth : (fieldConfig.fieldConfig[col]?.colwidth || 130)) + 'px', ...(isAlignmentSlot(col) ? { overflowX: 'auto', overflowY: 'hidden' } : {}) }}>
                                {(isAlignmentSlot(col) || col === 'SUBJECT_CT' || col === 'SUBJECT_Z3')
                                    && (tableState.fullRecordExpand[item.dbkey] || colIdx > 0) &&
                                    <span>
                                        {tableState.fullRecordExpand[item.dbkey] &&
                                            <span>&nbsp;</span>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && isAlignmentSlot(col) && !showFullSubject &&
                                            <pre className="ali-pre" style={toggle? {overflow: 'visible'}: {overflow: 'visible', backgroundColor: '#292929 !important', color: toggle ? 'black': selectedRowKey ===  (rowUniqueKey || item.dbkey) ? 'black' : 'white'}}><AlignmentHtmlWithTooltip html={data.gqAlignmentsNoSumm[item.dbkey]} /></pre>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && isAlignmentSlot(col) && showFullSubject &&
                                            <pre className="ali-pre ali-pre-flanking" style={{overflow: 'visible', whiteSpace: 'pre', width: 'max-content', ...(toggle ? {} : {backgroundColor: '#292929', color: selectedRowKey === (rowUniqueKey || item.dbkey) ? 'black' : 'white'})}}>
                                                {item.RESULT_NFALI_FORMATTED
                                                    ? <AlignmentHtmlWithTooltip html={buildFullSubjectAlignment(item, isCmNoSeq, buildExtendedCmTracks, lvaFlagMaps) || 'N/A'} />
                                                    : 'Loading full subject sequence...'}
                                            </pre>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && col === 'SUBJECT_CT' &&
                                            <span style={{overflow: 'visible'}}><SeqIdAlignmentPopup html={highlight(fieldConfig, filter, col, item[col], true)} data={data} patentNumber={item.SUBJECT_PN} /></span>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && col === 'SUBJECT_Z3' &&
                                            <span style={{overflow: 'visible'}}><SeqIdAlignmentPopup html={highlight(fieldConfig, filter, col, item[col], true)} data={data} patentNumber={item.SUBJECT_PN} /></span>
                                        }
                                    </span>
                                }
                                {(isAlignmentSlot(col) || col === 'SUBJECT_CT' || col === 'SUBJECT_Z3')
                                    && !tableState.fullRecordExpand[item.dbkey] && colIdx === 0 &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                                    }}>
                                        {!tableState.fullRecordExpand[item.dbkey] && isAlignmentSlot(col) && !showFullSubject &&
                                            <div>
                                                <pre style={{overflow: 'visible'}}><AlignmentHtmlWithTooltip html={data.gqAlignmentsNoSumm[item.dbkey]} /></pre>
                                            </div>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && isAlignmentSlot(col) && showFullSubject &&
                                            <div>
                                                <pre className="ali-pre ali-pre-flanking" style={{overflow: 'visible', whiteSpace: 'pre', width: 'max-content'}}>
                                                    {item.RESULT_NFALI_FORMATTED
                                                        ? <AlignmentHtmlWithTooltip html={buildFullSubjectAlignment(item, isCmNoSeq, buildExtendedCmTracks, lvaFlagMaps) || 'N/A'} />
                                                        : 'Loading full subject sequence...'}
                                                </pre>
                                            </div>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && col === 'SUBJECT_CT' &&
                                            <div>
                                                <span style={{overflow: 'visible'}}><SeqIdAlignmentPopup html={highlight(fieldConfig, filter, col, item[col], true)} data={data} patentNumber={item.SUBJECT_PN} /></span>
                                            </div>
                                        }
                                        {!tableState.fullRecordExpand[item.dbkey] && col === 'SUBJECT_Z3' &&
                                            <div>
                                                <span style={{overflow: 'visible'}}><SeqIdAlignmentPopup html={highlight(fieldConfig, filter, col, item[col], true)} data={data} patentNumber={item.SUBJECT_PN} /></span>
                                            </div>
                                        }
                                    </a>
                                }

                                {(col === 'SUBJECT_PC' || col === 'SUBJECT_SEQIDNOSUMM')
                                    && colIdx > 0 && item[col] && Object.keys(item[col]).length < 1 &&
                                    <div><span>&nbsp;</span></div>
                                }
                                {(col === 'SUBJECT_PC' || col === 'SUBJECT_SEQIDNOSUMM') && colIdx === 0 && item[col] && Object.keys(item[col]).length < 1 &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                                    }}><span>&nbsp;</span></a>
                                }
                                {col === 'SUBJECT_PC' && colIdx > 0 && item[col] && Object.keys(item[col]).length >= 1 &&
                                    <div><table className="classification">
                                        <tbody>
                                        {Object.keys(item[col]).map(
                                            (cls) => (
                                                <tr key={'pc_' + colIdx + cls}>
                                                    <td className="detail-label-sub">{cls}</td>
                                                    <td>{item[col][cls]}</td>
                                                </tr>
                                            )
                                        )}
                                        </tbody>
                                    </table></div>
                                }
                                {col === 'SUBJECT_PC' && colIdx === 0 && item[col] && Object.keys(item[col]).length >= 1 &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                                    }}>
                                        <table className="classification">
                                        <tbody>
                                        {Object.keys(item[col]).map(
                                            (cls) => (
                                                <tr key={'pc_' + colIdx + cls}>
                                                    <td className="detail-label-sub">{cls}</td>
                                                    <td>{item[col][cls]}</td>
                                                </tr>
                                            )
                                        )}
                                        </tbody>
                                        </table>
                                    </a>
                                }

                                {col === 'SUBJECT_SEQIDNOSUMM' && colIdx > 0 && item[col] && Object.keys(item[col]).length >= 1 &&
                                    <div><table className="classification">
                                        <tbody>
                                        {item[col]['Claim'] && Object.keys(item[col]['Claim']).length > 0 &&
                                            <tr>
                                                <td className="side-label">Claimed</td>
                                                <td>
                                                    {Object.keys(item[col]['Claim']).map(
                                                        (cls) => (
                                                            <div key={colIdx + cls}>
                                                                SEQ ID NO:{cls}
                                                                {item[col]['Claim'][cls] &&
                                                                    <span key={'span_' + colIdx + cls}> ({item[col]['Claim'][cls]})</span>
                                                                }
                                                            </div>
                                                            )
                                                        )}
                                                </td>
                                            </tr>
                                        }
                                        {item[col]['Disclosure'] && Object.keys(item[col]['Disclosure']).length > 0 &&
                                            <tr>
                                                <td className="side-label">Probable disclosure</td>
                                                <td>SEQ ID NOs:
                                                    {Object.keys(item[col]['Disclosure']).map(
                                                        (cls) => (
                                                            <span key={'span_' + colIdx + cls}> {cls}
                                                                {item[col]['Disclosure'][cls] &&
                                                                    <span key={'span2_' + colIdx + cls}> ({item[col]['Disclosure'][cls]})</span>
                                                                }
                                                            ;&nbsp;</span>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        }
                                        {item[col]['TBD'] && Object.keys(item[col]['TBD']).length > 0 &&
                                            <tr>
                                                <td className="side-label">TBD</td>
                                                <td>SEQ ID NOs:
                                                    {Object.keys(item[col]['TBD']).map(
                                                        (cls) => (
                                                            <span key={'span_' + colIdx + cls}> {cls}
                                                                {item[col]['TBD'][cls] &&
                                                                    <span key={'span2_' + colIdx + cls}> ({item[col]['TBD'][cls]})</span>
                                                                }
                                                                ;&nbsp;</span>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table></div>
                                }
                                {col === 'SUBJECT_SEQIDNOSUMM' && colIdx === 0 && item[col] && Object.keys(item[col]).length >= 1 &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                                    }}>
                                        <table className="classification">
                                            <tbody>
                                            {item[col]['Claim'] && Object.keys(item[col]['Claim']).length > 0 &&
                                                <tr>
                                                    <td className="side-label">Claimed</td>
                                                    <td>
                                                        {Object.keys(item[col]['Claim']).map(
                                                            (cls) => (
                                                                <div key={colIdx + cls}>
                                                                    SEQ ID NO:{cls}
                                                                    {item[col]['Claim'][cls] &&
                                                                        <span key={'span_' + colIdx + cls}> ({item[col]['Claim'][cls]})</span>
                                                                    }
                                                                </div>
                                                            )
                                                        )}
                                                    </td>
                                                </tr>
                                            }
                                            {item[col]['Disclosure'] && Object.keys(item[col]['Disclosure']).length > 0 &&
                                                <tr>
                                                    <td className="side-label">Probable disclosure</td>
                                                    <td>SEQ ID NOs:
                                                        {Object.keys(item[col]['Disclosure']).map(
                                                            (cls) => (
                                                                <span key={'span_' + colIdx + cls}> {cls}
                                                                    {item[col]['Disclosure'][cls] &&
                                                                        <span key={'span2_' + colIdx + cls}> ({item[col]['Disclosure'][cls]})</span>
                                                                    }
                                                                    ;&nbsp;</span>
                                                            )
                                                        )}
                                                    </td>
                                                </tr>
                                            }
                                            {item[col]['TBD'] && Object.keys(item[col]['TBD']).length > 0 &&
                                                <tr>
                                                    <td className="side-label">TBD</td>
                                                    <td>SEQ ID NOs:
                                                        {Object.keys(item[col]['TBD']).map(
                                                            (cls) => (
                                                                <span key={'span_' + colIdx + cls}> {cls}
                                                                    {item[col]['TBD'][cls] &&
                                                                        <span key={'span2_' + colIdx + cls}> ({item[col]['TBD'][cls]})</span>
                                                                    }
                                                                    ;&nbsp;</span>
                                                            )
                                                        )}
                                                    </td>
                                                </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </a>
                                }

                                {(col !== 'RESULT_FALI_FORMATTED' && col !== 'RESULT_EXTENDED_ALI' && col !== 'SUBJECT_CT' && col !== 'SUBJECT_PC' && col !== 'SUBJECT_SEQIDNOSUMM' && col !== 'VT_FT' && col !== 'SUBJECT_Z3')
                                    && colIdx > 0 &&
                                    <div className="clamped-text">
                                        <span dangerouslySetInnerHTML={{ __html: highlight(fieldConfig, filter, col, item[col], true) }}></span>
                                    </div>
                                }
                                {(col !== 'RESULT_FALI_FORMATTED' && col !== 'RESULT_EXTENDED_ALI' && col !== 'SUBJECT_CT' && col !== 'SUBJECT_PC' && col !== 'SUBJECT_SEQIDNOSUMM' && col !== 'SUBJECT_Z3')
                                    && colIdx === 0 &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        toggleFullRecordExpand(rowUniqueKey || item.dbkey);
                                    }}>
                                        <span>{ReactHtmlParser(highlight(fieldConfig, filter, col, item[col], true))}</span>
                                    </a>
                                }
                                {(col === 'VT_FT') &&
                                    <a href="#" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        openFtWindow(item);
                                    }}>
                                    <span>Full Text Document</span>
                                    </a>
                                }
                            </div>
                            </React.Fragment>
                        )
                    )
                }
            </div>
            {showAnnotationModal && <DiscoverAnnotationModal showModal={showAnnotationModal} type={type} dbkey={key} annotState={annotState} filter={filter}
                                     fieldConfig={fieldConfig} fromItemsPage={fromItemsPage} groupValue1={groupValue1} groupValue2={groupValue2}
                                     actionModal={callBack} closeModal={closeModal} value={value} parentAnnotState={parentAnnotState}
                                     annotGroup={annotGroup} annotGroupDisplay={annotGroupDisplay}
                                     subjectId={annotSubjectId} subjectPn={annotSubjectPn}/>}
        </Styles>
    )
}
